import axiosService from '../utils/axios';

class Server {
    static meta = {
        baseUrl: '/v1/admin',
    };

    static renewToken() {
        return axiosService({
            url: `${this.meta.baseUrl}/renewtoken`,
            method: 'post',
        });
    }

    static login(data) {
        return axiosService({
            url: `${this.meta.baseUrl}/login`,
            method: 'post',
            data,
        });
    }

    //
    static promptList(params) {
        return axiosService({
            url: `${this.meta.baseUrl}/prompt/list`,
            method: 'get',
            params,
        });
    }
    static visualPromptList(params) {
        return axiosService({
            url: `${this.meta.baseUrl}/visual-prompt/list`,
            method: 'get',
            params,
        });
    }

    static promptSave(data) {
        return axiosService({
            url: `${this.meta.baseUrl}/prompt/update`,
            method: 'post',
            data,
        });
    }

    static promptDelete(data) {
        return axiosService({
            url: `${this.meta.baseUrl}/prompt/delete`,
            method: 'post',
            data,
        });
    }

    // /register/channel/list
    static channelList(params) {
        return axiosService({
            url: `${this.meta.baseUrl}/register/channel/list`,
            method: 'get',
            params,
        });
    }

    // /add/register/channel
    static channelAdd(data) {
        return axiosService({
            url: `${this.meta.baseUrl}/add/register/channel`,
            method: 'post',
            data,
        });
    }

    // /update/register/channel
    static channelStatus(data) {
        return axiosService({
            url: `${this.meta.baseUrl}/update/register/channel`,
            method: 'post',
            data,
        });
    }

    // GPTS
    static gptsList(data) {
        return axiosService({
            url: `${this.meta.baseUrl}/gpts/list`,
            method: 'post',
            data,
        });
    }
    static updateGptsLike(data) {
        return axiosService({
            url: `${this.meta.baseUrl}/gpts/update-like`,
            method: 'post',
            data,
        });
    }

    static gptsTaskList(params) {
        return axiosService({
            url: `${this.meta.baseUrl}/gpts/task-list`,
            method: 'get',
            params,
        });
    }

    // user
    static userList(params) {
        return axiosService({
            url: `${this.meta.baseUrl}/user/list`,
            method: 'get',
            params,
        });
    }

    static userDetail(params) {
        return axiosService({
            url: `${this.meta.baseUrl}/user/detail`,
            method: 'get',
            params,
        });
    }
    static opencreate(data) {
        return axiosService({
            url: `${this.meta.baseUrl}/user/opencreate`,
            method: 'post',
            data,
        });
    }
    static batch_create_status(data) {
        return axiosService({
            url: `${this.meta.baseUrl}/batch/user/create_status`,
            method: 'post',
            data,
        });
    }
    static user_add_point(data) {
        return axiosService({
            url: `${this.meta.baseUrl}/user/add-point`,
            method: 'post',
            data,
        });
    }

    // manualPoints
    static manualPointsList(params) {
        return axiosService({
            url: `${this.meta.baseUrl}/manual-points/list`,
            method: 'get',
            params,
        });
    }

    // optimize
    static optimizeList(params) {
        return axiosService({
            url: `${this.meta.baseUrl}/optimize/list`,
            method: 'get',
            params,
        });
    }
    static getPromptRating(params) {
        return axiosService({
            url: `${this.meta.baseUrl}/prompt_score/list`,
            method: 'get',
            params,
        });
    }

    // analytics
    static get_views_count(params) {
        return axiosService({
            url: `${this.meta.baseUrl}/analyze/views`,
            method: 'get',
            params,
        });
    }

    static get_rate(params) {
        return axiosService({
            url: `${this.meta.baseUrl}/analyze/rate`,
            method: 'get',
            params,
        });
    }

    static get_login_rate(params) {
        return axiosService({
            url: `${this.meta.baseUrl}/analyze/outflow_rate`,
            method: 'get',
            params,
        });
    }

    // active
    static activeList(params) {
        return axiosService({
            url: `${this.meta.baseUrl}/active/list`,
            method: 'get',
            params,
        });
    }
    static addActive(data) {
        return axiosService({
            url: `${this.meta.baseUrl}/active/add`,
            method: 'post',
            data,
        });
    }
    static updataActive(data) {
        return axiosService({
            url: `${this.meta.baseUrl}/active/updata`,
            method: 'post',
            data,
        });
    }
    static activeRule() {
        return axiosService({
            url: `${this.meta.baseUrl}/active/rule`,
            method: 'get',
        });
    }

    // voucher
    static voucherList(params) {
        return axiosService({
            url: `${this.meta.baseUrl}/voucher/list`,
            method: 'get',
            params,
        });
    }
    static addVoucher(data) {
        return axiosService({
            url: `${this.meta.baseUrl}/voucher/add`,
            method: 'post',
            data,
        });
    }
    static updataVoucher(data) {
        return axiosService({
            url: `${this.meta.baseUrl}/voucher/update`,
            method: 'post',
            data,
        });
    }

    // config
    static updataConfig(data) {
        return axiosService({
            url: `${this.meta.baseUrl}/config/update`,
            method: 'post',
            data,
        });
    }
    static getConfig() {
        return axiosService({
            url: `${this.meta.baseUrl}/config`,
            method: 'get',
        });
    }

    // blog
    static blogList(params) {
        return axiosService({
            url: `${this.meta.baseUrl}/blog/list`,
            method: 'get',
            params,
        });
    }

    static blogAdd(data) {
        return axiosService({
            url: `${this.meta.baseUrl}/blog/add`,
            method: 'post',
            data,
        });
    }

    static blogUpdate(data) {
        return axiosService({
            url: `${this.meta.baseUrl}/blog/update`,
            method: 'post',
            data,
        });
    }

    static blogDelete(data) {
        return axiosService({
            url: `${this.meta.baseUrl}/blog/delete`,
            method: 'post',
            data,
        });
    }
}

export default Server;
